import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

// ═══════════ NEDEN SABİT SÜTUN SAYISI TERK EDİLDİ ═══════════
// Panel eskiden 12 sütunluk TEK bir ızgaraydı ve her kart SABİT bir `span` taşıyordu
// (çoğu 4, istatistik kutuları 3, departman grafiği 8). Kartların büyük kısmı MODÜLE BAĞLI
// koşullu render edildiği için bu yapı, müşterinin aldığı modüllere göre bozuluyordu:
//
//   • İzin ve Anket modülü olmayan bir müşteride üstteki dört kutudan ikisi düşüyor,
//     4×3=12 olan satır 2×3=6'ya iniyor ve satırın YARISI boş kalıyordu.
//   • Boşluğa bir sonraki bölümün kartı yukarı çekiliyor, bölümler birbirine karışıyordu.
//   • Grafik satırı zaten 8+3=11 sütundu, yani hiçbir modül eksik olmasa bile bir sütun açıktı.
//
// Yeni yapı: panel, her biri KENDİ ızgarasına sahip BÖLÜMLERDEN oluşan dikey bir yığın.
// Her bölüm `repeat(auto-fit, minmax(X, 1fr))` kullanır — sütun sayısı kart sayısına ve
// genişliğe göre kendiliğinden belirlenir, kaç kart olursa olsun satır TAM dolar. Kart
// sayısı modüle göre değiştiğinde yerleşim simetrik KALIR; artık kartların genişliği elle
// atanmaz, bu yüzden "iki kart eksilince yerleşim kayıyor" durumu yapısal olarak imkânsız.
//
// Ana panel ÇİFT padding'liydi: Layout.js → Main her sayfaya 16px veriyor, buradaki 16px
// üstüne biniyordu (toplam 32px) — uygulamadaki tek iki-kat girintili sayfa. Karşılaştırma:
// leave-dashboard/styles.js kökü padding: 0. Layout.js'e DOKUNULMAZ; orayı düşürmek her
// ekranı etkilerdi.
export const DashboardStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
`;

// Bölüm yerleşimi. `$min` bir kartın sığabileceği en dar genişlik; satır başına kaç kart
// düşeceği bundan çıkar.
//
// ═══════════ NEDEN GRID DEĞİL FLEX ═══════════
// İlk düzeltme `grid-template-columns: repeat(auto-fit, minmax($min, 1fr))` kullanıyordu.
// Bu, "kartlara elle span atama" sorununu çözdü ama SON SATIR sorununu bırakıyordu: sütun
// sayısı sabitlenir ve son satırdaki kart sayısı sütun sayısından azsa kalan sütunlar BOŞ
// kalır. Somut hâli grafiklerde görünüyordu — departman grafiği tam satır, altında iki grafik,
// üç sütunlu bir ızgarada üçüncü sütun delik. Aynı şey dokuz kartlık bölümde de oluyordu
// (7 kart / 3 sütun → son satırda bir kart, iki sütun boş).
//
// Flex'te satırın boş alanı O SATIRDAKİ kartlara dağıtılır (`flex-grow: 1`), yani son satır
// da tam dolar — kartlar yayılır, delik kalmaz. Grid'de bunun karşılığı yok: `auto-fit`
// yalnız HİÇ kart almayan kolonları toplar, kısmen dolu son satırı düzeltmez.
export const SectionGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 16px;

  /* Doğrudan çocuklar: taban genişlikte başlar, satırdaki artan alanı paylaşır.
     Alt sınır olmadan çok sayıda kart aynı satıra sıkışıp okunmaz hâle gelirdi.

     Paylaşım oranı ve taban, CSS DEĞİŞKENİYLE veriliyor. Sebebi özgüllük: kartın kendi
     sınıfı ile buradaki '> *' seçicisi aynı özgüllükte olduğundan hangisinin kazanacağı
     styled-components'in enjeksiyon sırasına kalırdı. Değişken kartın üstünde tanımlanıp
     buraya MİRAS yoluyla gelir; çatışma yok. Varsayılanlar korunduğu için oran belirtmeyen
     kartların davranışı değişmez. */
  > * {
    flex: var(--card-grow, 1) 1 var(--card-basis, ${({ $min }) => $min || '340px'});
    min-width: min(100%, var(--card-min, ${({ $min }) => $min || '340px'}));
  }
`;

// Geriye dönük uyumluluk: DashboardGrid adı hâlâ dışa açık ama artık sabit 12 sütun
// DEĞİL — yeni bölüm ızgarasının varsayılanı. Eski davranışa dönmek isteyen bir çağıran
// olursa yerleşimi sessizce bozmasın diye ad korunuyor.
export const DashboardGrid = SectionGrid;

// Kart artık KENDİ genişliğini belirlemez — bulunduğu bölümde esneyen bir öğedir ve satırın
// boş alanını kardeşleriyle paylaşır. (Eskiden her kart `span` taşıyordu; modüle bağlı kartlar
// düştüğünde satırlar delik kalıyordu. Bkz. DashboardStack yorumu.)
//
// `$grow` verilirse kart satırı KARDEŞLERİYLE ORANSAL paylaşır (ör. 9 ve 3 → 3'e 1). Bu bir
// piksel/sütun ataması DEĞİL, bir orandır: satırda kaç kart olursa olsun ve ekran ne kadar
// geniş olursa olsun aynı oran korunur. Kart yine kendi genişliğini atamaz — yalnız payını
// bildirir, alanı bölüm dağıtır.
//
// `$minWidth` oranlı kartın alt sınırını ayrıca düşürmek için: dar ekranda 3 birimlik kart
// bölümün genel alt sınırına takılıp oranı bozmasın diye.
export const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface.card};
  border-radius: ${({ theme }) => theme.metrics.radius.large};
  box-shadow: 0 1px 4px rgba(${({ theme }) => theme.colors.shadow.rgb}, 0.06);
  padding: 20px;
  animation: ${fadeIn} 0.4s ease-out;
  animation-fill-mode: both;
  animation-delay: ${({ $delay }) => $delay || '0s'};
  display: flex;
  flex-direction: column;
  min-height: 0;

  ${({ $grow }) => $grow && css`
    --card-grow: ${$grow};
    --card-basis: 0;
  `}
  ${({ $minWidth }) => $minWidth && css`
    --card-min: ${$minWidth};
  `}
`;

export const StatCard = styled.div`
  background: ${({ $gradient }) => $gradient || 'linear-gradient(135deg, #0291EF 0%, #02D3BF 100%)'};
  border-radius: 6px;
  padding: 20px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 16px;
  animation: ${fadeIn} 0.4s ease-out;
  animation-fill-mode: both;
  animation-delay: ${({ $delay }) => $delay || '0s'};
  cursor: default;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  }

`;

export const StatIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatContent = styled.div`
  flex: 1;
`;

export const StatValue = styled.div`
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 4px;
`;

export const StatLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  opacity: 0.85;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CardTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

export const CardBadge = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  background: ${({ $bg }) => $bg || '#E8F4FD'};
  color: ${({ $color }) => $color || '#0291EF'};
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #F0F2F5;

  &:last-child {
    border-bottom: none;
  }
`;

export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ $bg }) => $bg || 'linear-gradient(135deg, #0291EF, #02D3BF)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ListItemContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ListItemName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ListItemSub = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.dark?.medium || '#6B7280'};
  margin-top: 2px;
`;

export const ListItemBadge = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  background: ${({ $bg }) => $bg || '#E8F4FD'};
  color: ${({ $color }) => $color || '#0291EF'};
  white-space: nowrap;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: ${({ theme }) => theme.colors.text.dark?.medium || '#9CA3AF'};
  font-size: 13px;
  text-align: center;
  gap: 8px;
  flex: 1;
`;

export const ChartWrapper = styled.div`
  flex: 1;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ScrollList = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 280px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #E5E7EB;
    border-radius: 4px;
  }
`;
